import { render } from "./SalesPerStoreSkeleton.vue?vue&type=template&id=08bde974&scoped=true"
import script from "./SalesPerStoreSkeleton.vue?vue&type=script&lang=js"
export * from "./SalesPerStoreSkeleton.vue?vue&type=script&lang=js"

import "./SalesPerStoreSkeleton.vue?vue&type=style&index=0&id=08bde974&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bde974"]])

export default __exports__